
const m = window.require("ember-testing");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
